import { addLeadingZeros } from "../addLeadingZeros.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */

export const lightFormatters = {
  /*   */
  y(date, token) {
    /*                                                                                  */
    /*                                                */
    /*                                                */
    /*                                                */
    /*                                                */
    /*                                                */
    /*                                                */
    /*                                                */

    const signedYear = date.getFullYear();
    /*                                                 */
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },

  /*    */
  M(date, token) {
    const month = date.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },

  /*               */
  d(date, token) {
    return addLeadingZeros(date.getDate(), token.length);
  },

  /*       */
  a(date, token) {
    const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";

    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },

  /*          */
  h(date, token) {
    return addLeadingZeros(date.getHours() % 12 || 12, token.length);
  },

  /*          */
  H(date, token) {
    return addLeadingZeros(date.getHours(), token.length);
  },

  /*     */
  m(date, token) {
    return addLeadingZeros(date.getMinutes(), token.length);
  },

  /*     */
  s(date, token) {
    return addLeadingZeros(date.getSeconds(), token.length);
  },

  /*                 */
  S(date, token) {
    const numberOfDigits = token.length;
    const milliseconds = date.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3),
    );
    return addLeadingZeros(fractionalSeconds, token.length);
  },
};
